{
    "ChangeLayoutOptionTitle": "Click to see Dashboard layout options.",
    "NAME": "ChangeLayout"
}